import { TableHead } from 'components/table/TableHeadCustom';
import { INITIAL_LIST_PARAMS } from 'config';
import { CommentStatus } from 'types/comment';

export interface FormValuesProps {
  scan: string;
  created_at_start: Date | undefined;
  created_at_end: Date | undefined;
}

export const defaultCommentSearchValues = {
  scan: '',
  created_at_start: undefined,
  created_at_end: undefined,
};

export const COMMENT_TABLE_HEAD: TableHead = {
  checkbox: { label: '' },
  id: { label: 'ID' },
  name: { label: 'Автор' },
  text: { label: 'Комментарий' },
  rating: { label: 'Рейтинг' },
  status: { label: 'Статус' },
  attach_photo: { label: 'Вложения' },
  source: { label: 'Источник комментария' },
  updated_at: { label: 'Дата и время' },
  controls: { label: '' },
};

export const COMMENT_COMPLAINT_TABLE_HEAD: TableHead = {
  reason: { label: 'Причина обращения' },
  status: { label: 'Статус комментария' },
  source: { label: 'Источник комментария' },
  user: { label: 'Сотрудник' },
  controls: { label: '' },
};

export const COMMENT_DECLINATION = {
  one: 'комментарий',
  two: 'комментария',
  five: 'комментариев',
};

export enum COMMENT_TAB_VALUES {
  REVIEW = 'review',
  ALL = 'all',
  COMPLAINTS = 'complaints',
}

export const REVIEW_INITIAL_LIST_PARAMS = {
  ...INITIAL_LIST_PARAMS,
  status: [CommentStatus.CANCELLED],
  isReview: true,
  sort: 'desc',
  sort_by: 'updated_at',
};

export const ALL_INITIAL_LIST_PARAMS = {
  ...INITIAL_LIST_PARAMS,
  isReview: false,
  sort: 'desc',
  sort_by: 'updated_at',
};
